import React, { useState, ComponentType, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ToastNotification } from 'carbon-components-react';
import { useSelector } from 'react-redux';
import { withFormik } from 'formik';
import {
  RegistrationSchema,
  ConfirmRegistrationSchema
} from '../../utilities/validation';
import {
  RegistrationHero,
  RegistrationFooter,
  LanguageSelector
} from './components';
import { RegistrationForm, RegConfirmationForm } from './forms';
import {
  RegistrationDataTypes,
  USERSROLE,
  ConfirmationDataTypes,
  CFCProps,
  VIEW_MEMBERS_LEFT_NAV,
  VIEW_DASHBOARD_LEFT_NAV,
  VIEW_HOME_LEFT_NAV,
  APP_URL
} from 'types';
import Utils, { toLanguageType } from 'utilities/helper.util';
import { setGlobalAppLanguage } from 'services/lang.service';
import { setAppLang } from 'redux/app/actions';
import { selectIsAuthenticated, currentUser } from 'redux/session/selectors';
import {
  fetchRegRequest,
  fetchRegConfirmationRequest,
  fetchRegInit
} from 'redux/registration/action';
import { RootState } from 'redux/root.reducer';
import { setIsUserReg } from 'redux/session/actions';
import { UnAuthenticatedPageLayout } from 'layouts/unAuthenticatedPage.layout';
import Service from 'services';

export interface InitialFormProps {
  username: string;
  password: string;
}

export interface InitialConfirmFormProps {
  username: string;
  confirmatonCode: string;
}

export const Registration: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const history: any = useHistory();
  const user: any = useSelector(currentUser);
  const isAuthenticated: boolean = useSelector(selectIsAuthenticated);
  const isRegisteredUser: boolean = false; // useSelector(selectIsUserReg); //TODO:: no loger need but need confirmaion

  const [formValues, setFormValues] = useState<RegistrationDataTypes>({
    username: '',
    password: '',
    firstname: '',
    lastname: ''
  });

  const [formConfValues, setFormConfValues] = useState<ConfirmationDataTypes>({
    username: '',
    confirmationCode: ''
  });
  useEffect(() => {
    if (isAuthenticated && user) {
      const userRole = user.role;
      !Utils.isValidUserRole(USERSROLE, userRole) && Service.auth.ssoLogout();
      if (userRole) {
        Utils.isValidUserRole(VIEW_HOME_LEFT_NAV, userRole) &&
          history.push(APP_URL.LODGE_NEW_ENQUIRY);
        Utils.isValidUserRole(VIEW_MEMBERS_LEFT_NAV, userRole) &&
          history.push(APP_URL.MEMBERS);
        Utils.isValidUserRole(VIEW_DASHBOARD_LEFT_NAV, userRole) &&
          history.push(APP_URL.DASHBOARD);
      }
    }
  }, [isAuthenticated, user, history]);

  // Registration Component
  const RegistrationComponent: ComponentType<any> = withFormik<
    ConfirmationDataTypes,
    RegistrationDataTypes
  >({
    validationSchema: RegistrationSchema,
    mapPropsToValues: () => ({
      firstname: formValues?.firstname || '',
      lastname: formValues?.lastname || '',
      username: formValues?.username || '',
      password: formValues?.password || '',
      confirmPassword: formValues?.confirmPassword || ''
    }),
    handleSubmit: (values: RegistrationDataTypes, { setSubmitting }: any) => {
      setSubmitting(true);
      setFormValues(values);
      dispatch(fetchRegInit());
      dispatch(setIsUserReg(false));
      dispatch(fetchRegRequest(values));
    },
    displayName: 'RegistrationForm'
  })(RegistrationForm);

  // Reg Confirmation code
  const RegConfirmationComponent: ComponentType<any> = withFormik<
    InitialConfirmFormProps,
    ConfirmationDataTypes
  >({
    validationSchema: ConfirmRegistrationSchema,
    mapPropsToValues: () => ({
      username: formValues?.username || '',
      confirmationCode: formConfValues?.confirmationCode || ''
    }),
    handleSubmit: (values: ConfirmationDataTypes, { setSubmitting }: any) => {
      const password: string = formValues.password;
      const userName: string = formValues.username;
      const confirmationPayload: ConfirmationDataTypes = {
        username: userName,
        confirmationCode: values.confirmationCode,
        password
      };
      setFormConfValues(confirmationPayload);
      setSubmitting(true);
      dispatch(fetchRegConfirmationRequest(confirmationPayload));
    },
    displayName: 'RegConfirmationForm'
  })(RegConfirmationForm);

  const onLanguageChange = async (data: any) => {
    const language = toLanguageType(data.selectedItem?.value);
    await setGlobalAppLanguage(language);
    dispatch(setAppLang(language));
  };
  return (
    <div
      id="registration"
      className="full-page--backgroud"
      data-testid="registration"
    >
      <UnAuthenticatedPageLayout>
        <div className="full-page--backgroud-image">
          {/*FULL BG-IMAGE HOLDER*/}
        </div>
        <div className="registration-panel">
          <section className="registration-panel-section">
            <RegistrationHero />
            {props.reg.errors && (
              <ToastNotification
                lowContrast
                caption=""
                iconDescription="describes the close button"
                subtitle={props.reg.errors}
                timeout={0}
                title="Registration errors"
              />
            )}
          </section>
          <section className="registration-panel-section form-container">
            {!!props.reg.userName && isRegisteredUser ? (
              <RegConfirmationComponent />
            ) : (
              <RegistrationComponent />
            )}
          </section>
          <div className="registration-panel-section language-container">
            <LanguageSelector onChange={onLanguageChange} />
          </div>
          <div className="registration-panel-section">
            <RegistrationFooter />
          </div>
        </div>
      </UnAuthenticatedPageLayout>
    </div>
  );
};

const mapStateToProps = ({ reg }: RootState) => ({
  reg
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;
Registration.displayName = 'Registration';

export default connector(Registration);
